<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','min-width': '180px','max-width':'240px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
      no="1"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section"
          grid-style="min-width: 180px;width:100%;height:100%;"
          no="2"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div v-show="action==='look'">
              <!--返回查询-->
              <el-button type="primary" no="3" @click="goBack">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
              <!--编辑-->
              <el-button v-show="modelType !== 3" :disabled="!selectedRow" type="success" no="4" @click="editHandler('edit')">{{ $t('common.btn.edit') }}</el-button>
              <!--签单-->
              <el-button v-show="((modelType === 0 && $checkPermission(['role_CRMMyCustomerManager_sign'])) || modelType === 1 && $checkPermission(['role_CRMMyGroupCustomerManager_sign'])) && !isEditing" type="primary" no="5" @click="signHandler()">{{ $t('CargoMsg.Cargo_SignContract') }}</el-button>
              <!--分配-->
              <el-button v-show="modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_assign'])" type="primary" no="6" @click="assignEventHandler">{{ $t('CargoMsg.Cargo_Distribution') }}</el-button>
              <!--分配给我-->
              <el-button v-show="modelType == 2 && !isEditing" type="primary" no="7" @click="assignMyEventHandler">{{ $t('CargoMsg.Cargo_AssignToMe') }}</el-button>
              <!--删除-->
              <el-button v-show="modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_delete'])" type="primary" no="8" @click="deleteModelHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              <!--直接分配-->
              <el-button v-show="modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_assignDirect'])" type="primary" no="9" @click="assignDirectEventHandler">{{ $t('CargoMsg.Cargo_DirectAssign') }}</el-button>
              <!--恢复-->
              <el-button v-show="modelType == 3 && !isEditing && $checkPermission(['role_CRMRecoveryCustomerManager_recovery'])" type="primary" no="10" @click="recoveryHandler">{{ $t('CargoMsg.Cargo_Restore') }}</el-button>
            </div>
            <div v-show="action==='edit'" style="border-left:none;padding-left:0">
              <el-button type="success" no="11" @click="save">{{ $t('common.btn.save') }}</el-button>
              <el-button type="success" no="12" @click="cancelEdit(()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
            </div>
            <div v-show="isNew" class="new" style="border-left:none;padding-left:0">
              <el-button type="success" no="13" @click="save">{{ $t('common.btn.save') }}</el-button>
              <el-button type="success" no="14" @click="cancelEdit(goBack)">{{ $t('common.btn.cancel') }}</el-button>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <!--基础信息-->
              <el-tab-pane v-if="selectedRow" :key="1" :label="$t('CargoMsg.Cargo_BasicInformation')" :lazy="true" name="tabCrmCustomer">
                <tab-crm-customer ref="tabCrmCustomer" :model-type="modelType" :show-source-type="showSourceType" :context="context" :action="action" />
              </el-tab-pane>
              <!--联系人-->
              <el-tab-pane v-if="modelType === 0 ? (isShowTab && $checkPermission(['tab_TabCRMCustomerContact'])) : isShowTab" :key="2" :label="$t('CargoMsg.Cargo_Contact')" :lazy="true" name="tabCrmCustomerContact">
                <tab-crm-customer-contact ref="tabCrmCustomerContact" :model-type="modelType" :show-source-type="showSourceType" :context="context" :action="action" />
              </el-tab-pane>
              <!--业务特性-->
              <el-tab-pane v-if="isShowTab || modelType === 2" :key="3" :label="$t('CargoMsg.Cargo_BusinessCharacteristic')" :lazy="true" name="tabCrmCustomerBussiness">
                <tab-crm-customer-bussiness ref="tabCrmCustomerBussiness" :model-type="modelType" :show-source-type="showSourceType" :context="context" :action="action" />
              </el-tab-pane>
              <!--事件记录-->
              <el-tab-pane v-if="modelType === 0 ? (isShowTab && $checkPermission(['tab_TabCRMCustomerEvent'])) : isShowTab" :key="4" :label="$t('CargoMsg.Cargo_EventRecord')" :lazy="true" name="tabCrmCustomerEvent">
                <tab-crm-customer-event ref="tabCrmCustomerEvent" :model-type="modelType" :show-source-type="showSourceType" :context="context" :action="action" />
              </el-tab-pane>
              <!--文件资料-->
              <el-tab-pane v-if="modelType === 0 ? (isShowTab && !isNew && selectedRow.uuid && $checkPermission(['tab_TabCRMCustomerFile'])) : (isShowTab && !isNew && selectedRow.uuid)" :key="5" :label="$t('CargoMsg.Cargo_FileDocumentation')" :lazy="true" name="tabCrmCustomerFile">
                <tab-crm-customer-file ref="tabCrmCustomerFile" :model-type="modelType" :show-source-type="showSourceType" :context="context" :action="action" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 签单弹框-->
    <sign-match-title-window
      :visible.sync="signMatchTitleWindow.visible"
      :enabled-no-join="true"
      :client="selectedRow || {}"
      no="15"
      @signSuccessCallBack="signSuccessCallBackHandler"
    />

    <!-- 分配弹框 -->
    <el-dialog
      v-if="customerAssignWindow.visible"
      v-el-drag-dialog
      :visible.sync="customerAssignWindow.visible"
      :title="$t('CargoMsg.Cargo_Distribution')"
      width="360px"
      :close-on-click-modal="false"
      no="16"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Payment.sales')">
          <cargo-user-select
            :method-params="{category:'role',shape:'sales'}"
            :default-value="customerAssignWindow.sales||''"
            style="width: 230px;"
            no="17"
            @change="p=>{customerAssignWindow.sales=p.value||0}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="18" @click="enterAssignHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="19" @click="customerAssignWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 验证规则弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import tabCrmCustomer from '@/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomer'
import tabCrmCustomerBussiness from '@/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerBussiness'
import tabCrmCustomerContact from '@/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerContact'
import tabCrmCustomerEvent from '@/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerEvent'
import tabCrmCustomerFile from '@/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerFile'
import signMatchTitleWindow from '@/views/cargo/v0/Sales/components/crm/signMatchTitleWindow'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import { TabError } from '@/utils/class/TabError'
import { cacheName, cache } from '@/utils/cacheManager'
import {
  assignQuotationClients,
  assignQuotationClientsAndApprove,
  saveQuotationClient,
  validateQuotationClient,
  updateQuotationClientField
} from '@/api/sales/quotationClient'
import { User } from '@/class/model/sys/User'
import { deleteCustomer } from '@/api/company'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'

export default {
  name: 'CustomerWorkspace',
  components: {
    cargoAdvanceSelect, cargoLeftRightResize, cargoUserSelect,
    tabCrmCustomer, tabCrmCustomerBussiness, tabCrmCustomerContact,
    tabCrmCustomerEvent, tabCrmCustomerFile, signMatchTitleWindow,
    checkingSaveJobWindow
  },
  props: {
    modelType: { type: Number, required: true, default: 1 }, // 模块类型 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
    showSourceType: { type: Boolean, required: false, default: true } // 是否显示客户来源
  },
  data() {
    return {
      context: {},
      selectTypeNames: TYPE_NAMES,
      SystemConstants,
      action: 'look',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_ClientList'),
            colId: 'name',
            field: 'name',
            tooltip: (params) => {
              return params.data ? params.data.name : ''
            },
            suppressMenu: true,
            width: 200
          }
        ],
        context: {
          componentParent: this
        },
        onRowClicked: e => this.changeJob(e.data)
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      pendTabSet: new Set(),
      isRefresh: true,
      activeTabName: '',
      signMatchTitleWindow: { // 签单
        visible: false
      },
      isGetNewJobInfoFromDb: true, // 是否从数据库中加载数据
      customerStatusCode: -1, // 状态，潜在客户
      customerAssignWindow: { // 分配
        visible: false,
        sales: '',
        type: 0, // 0 分配 1、直接分配
        selectedItems: []
      },
      selectedRow: new QuotationClient().fillDefaultValue().getData(), // 创建一个默认的
      checkingSaveJobWindow: {
        lob: '',
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      }
    }
  },
  computed: {
    isNew() {
      return this.action === 'add'
    },
    isEditing() {
      return this.action !== 'look'
    },
    isShowTab() {
      return this.selectedRow && this.selectedRow.ownerId && parseInt(this.selectedRow.ownerId) > 0
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.selectedRow = selectedRow
      this.customerStatusCode = selectedRow.customerStatusCode
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (selectedRow.uuid) {
        this.rowData = rowData
      } else {
        this.buildNewRow(selectedRow)
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
      })
    },
    // 新增时 填充默认值
    buildNewRow(quotationClient) {
      const rowBackup = lodash.cloneDeep(quotationClient)
      const isNew = !Object.keys(quotationClient).length

      new QuotationClient(quotationClient)
      quotationClient.ownerId = this.$store.getters.userInfo.userId
      if (this.modelType === 0) { // 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
        quotationClient.preOwnerId = this.$store.getters.userInfo.userId
      }
      quotationClient.groupLeaderId = this.$store.getters.userInfo.manager
      quotationClient.departmentId = this.$store.getters.userInfo.defaultDepId
      if (!this.$store.getters.userInfo.defaultOfficeId || parseInt(this.$store.getters.userInfo.defaultOfficeId) <= 0) {
        quotationClient.branchId = this.$store.getters.currentOffice.officeId
      } else {
        quotationClient.branchId = this.$store.getters.userInfo.defaultOfficeId
      }
      quotationClient.firstMeetDate = new Date()
      quotationClient.assignDate = new Date()
      quotationClient.signedDays = CrmCustomerConstants.COMPANY_DEFAULT_SIGNED_DAYS
      quotationClient.sleepDays = CrmCustomerConstants.COMPANY_DEFAULT_SLEEP_DAYS
      quotationClient.dueTime2 = CrmCustomerConstants.COMPANY_DEFAULT_SLEEP_DAYS
      quotationClient.active = true
      quotationClient.approvedState = 1
      quotationClient.customerStatusCode = this.customerStatusCode

      // 新增时初始化某些数据
      quotationClient.clientId = 0
      quotationClient.companySize = 1
      quotationClient.registeredCapital = 1
      quotationClient.companyTypeCode = 0
      quotationClient.customerStatusCode =
      quotationClient.customerLevelCode = 0
      quotationClient.overcomeLevelCode = 0
      quotationClient.country = 'CN'
      quotationClient.province = ''
      quotationClient.city = ''
      quotationClient.districts = ''
      if (!isNew) {
        Object.assign(quotationClient, rowBackup)
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getModel().rowsToDisplay
      this.gridApi.clearFocusedCell()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid
        const rowKey = row.uuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    // 左侧列表切换job
    async changeJob(result) {
      if (result) {
        // 重新数据库中加载job
        this.isGetNewJobInfoFromDb = true
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onShow(this.action, this.rowData, result)
        // console.log('changeJob====', event.data, event.data.seaEQ, event.data.lclSlaves)
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      this.currentRow = event.data
      const dueTime2 = this.currentRow.dueTime2 // 即将到期天数 查询之前存一次，详情显示使用
      // 加载job详细信息
      if (this.isGetNewJobInfoFromDb) {
        const jobModel = new QuotationClient(this.currentRow)
        if (this.currentRow.uuid) {
          const loading = getLoading4Cxt(this)
          await jobModel.loadQuotationClientRelated({
            client: true,
            contact: true,
            business: true,
            event: true
          }).finally(() => {
            loading.close()
          })
        } else {
          jobModel.quotationClientContact = null
          jobModel.quotationClientBusiness = null
          jobModel.quotationClientEvent = null
        }
        this.currentRow.dueTime2 = dueTime2
        this.isGetNewJobInfoFromDb = false
        // console.log('onRowClicked====', this.currentRow, this.currentRow.quotationClientContact, this.currentRow.quotationClientBusiness, this.currentRow.quotationClientEvent)
      }
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 编辑
    editHandler(action) {
      this.againShow(action)
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存客户信息
    async save() {
      const loading = getLoading4Cxt(this)
      try {
        // 当前页签结束后的处理
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = { action: this.action, officeId: this.$store.getters.currentOfficeId }
        // 合并各页签的提交数据
        try {
          for (const item of this.pendTabSet) {
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              const tabData = this.$refs[item].getSubmitData()
              this.mergeObjectWithUuid(body, tabData)
            }
          }
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            loading.close()
            return
          } else {
            throw err
          }
        }
        if (!body.quotationClient) body.quotationClient = this.currentRow
        // 判断有新增的事件 更新未跟进天数
        await this.checkUnAskDays(body)
        // 在保存前进行校验
        if (!(await this.checkBeforeSave(body))) {
          loading.close()
          return
        }
        loading.close()
        await this.doCheckNodeAndSave(body)
      } catch (err) {
        loading.close()
        throw err
      }
    },
    async doCheckNodeAndSave(body) {
      if (Number(cache.config.get('useCheckRule')) === 1) {
        let checkResult = null
        let needShowDialog = false
        const loading = getLoading4Cxt(this)
        await checkAnyContent(body.quotationClient ? body : { ...body, quotationClient: this.currentRow }, CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code).then(res => {
          checkResult = res.data
          for (const checkRule of checkResult) {
            if (checkRule && checkRule.expressions) {
              for (const item of checkRule.expressions) {
                if (!item.match) {
                  needShowDialog = true
                  break
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }).finally(() => loading.close)
        if (needShowDialog) {
          const callBack = () => { this.doSave(body) }
          this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code
          this.checkingSaveJobWindow.rowData = checkResult
          this.checkingSaveJobWindow.callBack = callBack
          this.checkingSaveJobWindow.visible = true
        } else {
          await this.doSave(body)
        }
      } else {
        await this.doSave(body)
      }
    },
    // 保存到数据库
    async doSave(body) {
      const loading = getLoading4Cxt(this)
      await saveQuotationClient(body).then(res => {
        loading.close()
        const result = res.data
        if (result) {
          Object.assign(this.currentRow, result)
          this.isRefresh = true
          this.isGetNewJobInfoFromDb = true
        }
        if (this.isNew) {
          this.gridApi.setRowData(this.rowData)
        }
        this.againShow('look')
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).catch(() => {
        loading.close()
      })
    },
    // 合并对象属性，通过比较uuid判断对象是否相等
    mergeObjectWithUuid(target, source) {
      for (const key in source) {
        const srcValue = source[key]
        const targetValue = target[key]
        if ((srcValue instanceof Array) && (targetValue instanceof Array)) {
          for (const item of srcValue) {
            const index = targetValue.findIndex(p => p.uuid === item.uuid && p.uuid)
            if (index < 0) {
              targetValue.push(item)
            }
          }
        } else {
          target[key] = srcValue
        }
      }
    },
    // 保存前校验
    async checkBeforeSave(body) {
      this.$logger.log('body111=====', body)
      const item = {}
      const _quotationClient = body.quotationClient
      item.branchId = _quotationClient.branchId
      if (_quotationClient.uuid) {
        item.uuid = _quotationClient.uuid
      }
      if (_quotationClient.name) {
        item.name = _quotationClient.name
      }
      if (_quotationClient.englishName) {
        item.englishName = _quotationClient.englishName
      }
      const requestBody = { conMap: item }
      const flag = await validateQuotationClient(requestBody).then(evt => {
        const existContacts = evt.data.existContacts
        const exist = evt.data.exist
        const name = evt.data.name
        const englishName = evt.data.englishName
        if (exist) {
          if (name) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameAlreadyExists'))
            this.activeTabName = 'tabCrmCustomer'
            return false
          }
          if (englishName) {
            this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameAlreadyExists'))
            this.activeTabName = 'tabCrmCustomer'
            return false
          }
          this.$message.warning(this.$t('CargoMsg.Cargo_ChineseOrEnglishAlreadyExists'))
          this.activeTabName = 'tabCrmCustomer'
          return false
        }

        const quotationClientContact = body.quotationClientContact
        if (!quotationClientContact || quotationClientContact.length < 1) {
          if (!existContacts) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ContactPersonToFillInA'))
            this.activeTabName = 'tabCrmCustomerContact'
            this.pendTabSet.add(this.activeTabName)
            if (this.isShowTab && this.$refs['tabCrmCustomerContact'] && this.$refs['tabCrmCustomerContact'].rowData) {
              this.$refs['tabCrmCustomerContact'].rowData = []
            }
            return false
          }
        }
        if (quotationClientContact && quotationClientContact.length > 0) {
          for (const contact of quotationClientContact) {
            if (!contact.name || !contact.phone) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CNATCBE'))
              this.activeTabName = 'tabCrmCustomerContact'
              this.pendTabSet.add(this.activeTabName)
              return false
            }
          }
        }

        if (!_quotationClient.uuid) {
          _quotationClient.branchId = this.$store.getters.currentOfficeId
        }
        return true
      })
      return flag
    },
    // 刷新未跟进天数
    async checkUnAskDays(body) {
      const _quotationClient = body.quotationClient
      const openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
      if (openSapConfig && _quotationClient.quotationClientEvent && _quotationClient.quotationClientEvent.length > 0) {
        for (const event of _quotationClient.quotationClientEvent) {
          if (!event.uuid) {
            _quotationClient.unAskDays = 0
          }
        }
      }
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.isGetNewJobInfoFromDb = true
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.currentRow, isRefresh)
      })
    },
    // 签单
    signHandler() {
      const client = this.selectedRow
      if (!client) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckClient'))
        return
      }
      if (!client.ownerId || client.ownerId <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SalesIsEmpty'))
        return
      }
      if (client.signed) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrentClientIsContracted'))
        return
      }
      this.signMatchTitleWindow.visible = true
    },
    // 签单成功重新查询
    signSuccessCallBackHandler() {
      this.changeJob(this.selectedRow)
    },
    // 分配
    assignEventHandler() {
      this.assignCommonHandler(0)
    },
    // 直接分配
    assignDirectEventHandler() {
      this.assignCommonHandler(1)
    },
    // 分配 直接分配公用
    assignCommonHandler(type) {
      const selectedItems = [this.currentRow]
      if (!this.currentRow || !selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomerNotSelected'))
        return
      }
      this.customerAssignWindow.sales = ''
      this.customerAssignWindow.type = type
      this.customerAssignWindow.selectedItems = selectedItems
      this.customerAssignWindow.visible = true
    },
    // 确认分配
    enterAssignHandler() {
      if (!this.checkSales()) return
      const clientKeys = Array.from(this.customerAssignWindow.selectedItems, p => p.uuid)
      const conMap = {
        ownerId: this.customerAssignWindow.sales,
        sourceType: CrmCustomerConstants.SOURCE_TYPE_LEADER_ASSIGN.code
      }
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      // 分配
      if (this.customerAssignWindow.type === 0) {
        const loading = getLoading4Cxt(this)
        assignQuotationClientsAndApprove(requestBody).then(res => {
          this.assignResultHandler(res)
        }).finally(() => {
          this.customerAssignWindow.visible = false
          loading.close()
        })
        return
      }
      // 直接分配
      if (this.customerAssignWindow.type === 1) {
        const loading = getLoading4Cxt(this)
        assignQuotationClients(requestBody).then(async res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AllocationSucceeded', [this.customerAssignWindow.selectedItems.length]))
          this.refreshAgGrid()
          await this.changeJob(this.currentRow)
        }).finally(() => {
          this.customerAssignWindow.visible = false
          loading.close()
        })
      }
    },
    // 分配 及 分配给我 结果处理
    async assignResultHandler(event) {
      const item = event.data
      // console.log('item==============', item)
      const sameList = item['same']
      const diffList = item['diff']
      let content = ''
      if (diffList.length > 0) {
        for (const q of diffList) {
          const chineseName = q.name ? q.name : this.$t('CargoMsg.Cargo_ChineseNameIsEmpty')
          let oldGroupLeader = ''
          const user = await User.getUserById(q.groupLeaderId)
          if (user) {
            oldGroupLeader = user.chineseName ? user.chineseName : this.$t('CargoMsg.Cargo_OriginalTeamLeaderIsEmpty')
          }
          content += this.$t('CargoMsg.Cargo_CustomerName') + '：' + chineseName + '<br>' + this.$t('CargoMsg.Cargo_FormerGroupLeader') + '：' + oldGroupLeader + '<br><br>'
        }
      }
      this.refreshAgGrid()
      await this.changeJob(this.currentRow)
      if (sameList.length > 0 && diffList.length < 1) {
        await this.$confirm(this.$t('CargoMsg.Cargo_AllocationSucceeded'), this.$t('CargoMsg.Cargo_Distribution'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'success'
        })
      } else if (diffList.length > 0 && sameList.length < 1) {
        const message = this.$t('CargoMsg.Cargo_ReviewedByLeader') + '<br>'
        await this.$confirm(message + content, this.$t('CargoMsg.Cargo_Distribution'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'success'
        })
      }
    },
    // 验证销售
    checkSales() {
      if (!this.customerAssignWindow.sales || parseInt(this.customerAssignWindow.sales) === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SalesNotSelected'))
        return false
      }
      return true
    },
    // 分配给我
    assignMyEventHandler() {
      const ownerId = this.$store.getters.userId// 销售即为当前用户
      if (this.currentRow.preOwnerId && ownerId === parseInt(this.currentRow.preOwnerId) && parseInt(this.currentRow.preOwnerId) !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoNotOperate'))
        return
      }
      const clientKeys = [this.currentRow.uuid]
      const conMap = {
        ownerId: ownerId,
        sourceType: CrmCustomerConstants.SOURCE_TYPE_SALE_OBTAIN.code
      }
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      const loading = getLoading4Cxt(this)
      assignQuotationClientsAndApprove(requestBody).then(res => {
        this.assignResultHandler(res)
      }).finally(() => {
        loading.close()
      })
    },
    // 删除
    deleteModelHandler() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectForDelete'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureDelete'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const requestBody = {
          conMap: { clientKey: this.currentRow.uuid },
          branchId: this.$store.getters.currentOfficeId
        }
        const loading = getLoading4Cxt(this)
        deleteCustomer(requestBody).then(res => {
          const result = res.data
          if (result === 1) {
            this.$message.success(this.$t('CargoMsg.Cargo_DeleteSuccessfully'))
            this.refreshAgGrid(true)
          } else if (result === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFailed'))
          } else if (result === 2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CannotBeDeleted'))
          }
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    // 客户公海只需要 销售为空 且 有效的客户
    refreshAgGrid(isDelete = false) {
      if (this.modelType === 2) {
        if (isDelete) {
          this.rowData = this.rowData.filter(p => p.ownerId && !p.active)
        } else {
          this.rowData = this.rowData.filter(p => parseInt(p.clientId) !== parseInt(this.currentRow.clientId))
        }
        if (this.rowData.length > 0) {
          this.currentRow = this.rowData[0]
          this.setGridSelect(this.currentRow)
        } else {
          this.goBack()
        }
      }
    },
    // 恢复
    recoveryHandler() {
      if (!this.currentRow) {
        this.$message.success(this.$t('CargoMsg.Cargo_CustomerInformationIsEmpty'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_RestoreCurrentCustomer'), this.$t('CargoMsg.Cargo_ConfirmNotification'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const clientKeys = [this.currentRow.uuid]
        const requestBody = {
          conMap: { active: true },
          clientKeys: clientKeys,
          branchId: this.$store.getters.currentOfficeId
        }
        const loading = getLoading4Cxt(this)
        updateQuotationClientField(requestBody).then(res => {
          const index = this.rowData.findIndex(p => p.uuid === this.currentRow.uuid)
          this.rowData.splice(index, 1)
          this.isRefresh = true
          if (this.rowData.length > 0) {
            this.onShow('look', this.rowData, this.rowData[0])
          } else {
            this.goBack()
          }
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    // 返回
    goBack() {
      this.isGetNewJobInfoFromDb = true
      this.activeTabName = 'basicTab'
      this.$emit('back', this.isRefresh)
    }
  }
}
</script>
